<template>
    <div id="calendar-month" 
        class="calendar-row-0"
        >
        <!--
            :class="'calendar-month-offset-'+firstOfMonthOffset"
        -->

        <!-- <div class="calendar-month-name">{{pageName}}</div> -->
        <!--
        <div v-for="day in dateList.slice(0,7)" :key="`weekday-${day.getDate()}`"
            class="calendar-month-day-name calendar-row-0"
            :class="calcColumn(day)">
            {{dayName(day)}}
        </div>

        <div v-for="day in dateList" :key="`day-${day.getDate()}`"
            class="calendar-month-day"
            :class="[{
                'calendar-before': isBeforeEvent(day),
                'calendar-after': isAfterEvent(day)
            },
                calcColumn(day)
            ]">
            <div class="calendar-month-day-num calendar-item"
              :disabled="isBeforeEvent(day) || isAfterEvent(day)"
              @click="doDay(day)"
              title="View day"
            >{{day.getDate()}}</div>

            <OverflowContainer :count="itemsForDay(day) ? itemsForDay(day).length : 0"
                @click="doDay(day)"
                :title="'View day'"
            >
                <CalendarItem 
                    v-for="item in itemsForDay(day)" :key="`calitem-${item.id}`"
                    :item="item"
                    :timezone="timezone"
                    @click="doModal(item)"
                >
                    <CalendarIcon :item="item" :me="me" class="tiny" />
                    <CalendarItemDetailsShort 
                        :item="item"
                        :timezone="timezone"
                    />
                </CalendarItem>
            </OverflowContainer>

        </div>
        -->
        <div v-for="cur in dateKeyRange.slice(0,7)" :key="`weekday-${cur.key}`"
            class="calendar-month-day-name calendar-row-0"
            :class="calcColumn(cur.col)">
            {{dayNameFromKey(cur.key, timezone)}}
        </div>
        <div v-for="cur in dateKeyRange" :key="`day-${cur.key}`"
            class="calendar-month-day"
            :class="[{
                'calendar-inactive': !cur.during,
//                'calendar-before': isBeforeEvent(day),
//                'calendar-after': isAfterEvent(day)
            },
                calcColumn(cur.col)
            ]">
            <div class="calendar-month-day-num calendar-item"
              :disabled="!cur.active"
              @click="cur.active ? doDay(cur.key) : null"
              title="View day"
            >{{cur.key.slice(-2)}}</div>

            <OverflowContainer :count="itineraryByDate[cur.key] ? itineraryByDate[cur.key].length : 0"
                @click="doDay(cur.key)"
                :title="'View day'"
            >
                <CalendarItem 
                    v-for="item in itineraryByDate[cur.key]" :key="`calitem-${item.id}`"
                    :item="item"
                    :timezone="timezone"
                    @click="doModal(item)"
                >
                    <CalendarIcon :item="item" :me="me" class="tiny" />
                    <CalendarItemDetailsShort 
                        :item="item"
                        :timezone="timezone"
                    />
                </CalendarItem>
            </OverflowContainer>

        </div>

    </div>
</template>

<script>
import OverflowContainer from "@/components/OverflowContainer";
// import {asNaiveDateISO} from '@/utils/DateTime';
import { dayNameFromKey, firstOfMonthObj, lastOfMonthObj } from '@/utils/DateTime';

import {dateToKey} from '@/utils/Sort';
import CalendarIcon from "@/views/calendar/CalendarIcon";
import CalendarItem from "@/views/calendar/CalendarItem";
import CalendarItemDetailsShort from "@/views/calendar/CalendarItemDetailsShort";

// Default to showing the start month of the event
export default {
    name: "CalendarMonth",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    components: {
        CalendarIcon,
        CalendarItem,
        CalendarItemDetailsShort,
        OverflowContainer,
    },
    computed: {
        dateKeyRange() {
            // Precalculate the key, col, active values
            /*
            let dtPage = new Date(this.pageDate);
            let first = new Date(dtPage);
            first.setDate(1);  // 0-6 0==Sunday
            let last = new Date(
                first.getYear(),
                first.getMonth() +1, // Zeroth day of next month (months are 0-indexed)
                0
            );
            */
            let first = firstOfMonthObj(this.pageDate, this.timezone);
            let last = lastOfMonthObj(this.pageDate, this.timezone);
            let daysInMonth = last.getDate();
            let firstKey = dateToKey(first);
            // let lastKey = dateToKey(last);
            let curCol = first.getDay();

            let keys = [
                {
                    key: firstKey,
                    col: curCol,
                    during: this.eventDates.includes(firstKey),
                    active: this.activeDates.includes(firstKey)
                }
            ];
            for (let x=1; x<daysInMonth; x++) {
                curCol++;
                if (curCol > 6) { curCol = 0; }

                let cur = new Date(first);
                cur.setDate(first.getDate()+x);
                let curKey = dateToKey(cur);

                keys.push({
                    key: curKey,
                    col: curCol,
                    during: this.eventDates.includes(curKey),
                    active: this.activeDates.includes(curKey)
                });
            }
            return keys;
        },
        /*
        eventStart() {
            return new Date(this.event.start_tz);
        },
        eventEnd() {
            let dtEnd = new Date(this.event.end_tz);
            //dtEnd.setHours(23,59,59);
            return dtEnd;
        },
        firstOfMonth() {
            let fom = new Date(this.pageDate);
            fom.setDate(1); // Returns milliseconds since epoch :-|
            return fom;
        },
        firstOfMonthOffset() {
            return this.firstOfMonth.getDay();
        },
        lastOfMonth() {
            return new Date(
                this.firstOfMonth.getYear(),
                this.firstOfMonth.getMonth() +1, // Zeroth day of next month (months are 0-indexed)
                0
            );
        },
        daysInMonth() {
            return this.lastOfMonth.getDate();
        },
        dateList() {
            let dates = [this.firstOfMonth];
            for (let x=2; x<= this.daysInMonth; x++) {
                let curDate = new Date(this.firstOfMonth);
                curDate.setDate(x);
                dates.push(curDate);
            }
            return dates;
        },
        monthNum() {
            return this.firstOfMonth.getMonth();
        },
        pageName() {
            return new Intl.DateTimeFormat(navigator.language, {month: 'long', year: 'numeric'}).format(this.firstOfMonth);
        },
        */
        // orderedByDay() {
        //     return groupByDate(this.items, 'start_time_utc', this.timezone);
        // },
    },
    methods: {
        dayNameFromKey,
        /*
        dayNameFromKey(dateKey) {
            return new Intl.DateTimeFormat(navigator.language, {weekday: 'long'}).format(new Date(dateKey));
        },
        */
        calcColumn(col) {
            return `calendar-col-${col}`;
        },
        /*
        dayName(dateObj) {
            return new Intl.DateTimeFormat(navigator.language, {weekday: 'long'}).format(dateObj);
        },
        isBeforeEvent(dateObj) {
            let naiveDate = asNaiveDateISO(dateObj);
            return naiveDate < this.event.start; // STRING COMPARISON!
            // return dateObj < this.eventStart;
        },
        isAfterEvent(dateObj) {
            let naiveDate = asNaiveDateISO(dateObj);
            return naiveDate > this.event.end; // STRING COMPARISON!
            // return dateObj > this.eventEnd;
        },
        itemsForDay(dateObj) {
            // let key = dateToKey(dateObj); // Don't include the timezone - the table is tz-neutral
            let key = asNaiveDateISO(dateObj);
            // console.log("KEY:",key);
            // return this.itemsByDate[key];
            return this.itineraryByDate[key];
        },
        */
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.items
            });
        },
        doDay(day) {
            this.$emit('day', day);
        }
    },
}
</script>

<style>
#calendar-month {
  border: 1px solid #ddd;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 100%;
  background: #ddd;
  gap: 1px;
}

.calendar-month-name {
    grid-column: 1 / span 7;
    background: #fff;
    font-weight: bold;
}
.calendar-month-day-name {
    background: #fff;
    font-size: 12px;
    padding: 0 2px;
}

.calendar-month-day {
    background: #fff;
    font-size: 12px;
    height: 100px;
    overflow: hidden;
    position: relative;
    padding: 0 2px 2px 2px;
}

/* .calendar-month-item-count {
    position: absolute;
    bottom: 0;
    background: #fff;
    display: flex;
    align-items: center;
}
.calendar-month-item-count {
    display: inline-block;
    background: #000;
    color: #fff;
    padding: 2px;
    border-radius: 3px;
} */

.calendar-inactive,
.calendar-before,
.calendar-after {
    background: #eee;
    /* color: #666; */
}


.calendar-col-0 { grid-column: 1;}
.calendar-col-1 { grid-column: 2;}
.calendar-col-2 { grid-column: 3;}
.calendar-col-3 { grid-column: 4;}
.calendar-col-4 { grid-column: 5;}
.calendar-col-5 { grid-column: 6;}
.calendar-col-6 { grid-column: 7;}

.calendar-row-0 { grid-row: 1;}
.calendar-row-1 { grid-row: 2;}


/* CalendarItem customisation! */
#calendar-month .calendar-schedule-detail { xdisplay: none;}

#calendar-month .calendar-item {
    xpadding: 5px;
}
#calendar-month .calendar-icon {
    margin-top: 1px;
    margin-right: 3px;
}
#calendar-month .calendar-schedule-status {
    margin: 0 3px;
}

#calendar-month .calendar-schedule-detail {
    text-overflow: ellipsis;
    /* width: 50px; */
    overflow: hidden;
    white-space: nowrap;
}
</style>